import { CONTENT_SECTION_ACTION_TYPE } from "./content-section.action";

export const contentSectionMessageContext = {
	get: CONTENT_SECTION_ACTION_TYPE.get,
};
